/**
 * @generated SignedSource<<c2f0ec532ee9d1c2e529b6bf240d4173>>
 * @relayHash 553c849de5d7c5a49bb06b6dec679dfc
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 553c849de5d7c5a49bb06b6dec679dfc

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deleteProgressNoteInput = {
  id: string;
};
export type chDeleteProgressNoteMutation$variables = {
  connections: ReadonlyArray<string>;
  input: Ch_deleteProgressNoteInput;
};
export type chDeleteProgressNoteMutation$data = {
  readonly deleteProgressNote: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly progressNote: {
      readonly id: string;
    } | null;
  };
};
export type chDeleteProgressNoteMutation = {
  response: chDeleteProgressNoteMutation$data;
  variables: chDeleteProgressNoteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "chDeleteProgressNoteMutation",
    "selections": [
      {
        "alias": "deleteProgressNote",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_deleteProgressNotePayload",
        "kind": "LinkedField",
        "name": "ch_deleteProgressNote",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "progressNote",
            "args": null,
            "concreteType": "ch_ProgressNote",
            "kind": "LinkedField",
            "name": "ch_ProgressNote",
            "plural": false,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "chDeleteProgressNoteMutation",
    "selections": [
      {
        "alias": "deleteProgressNote",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_deleteProgressNotePayload",
        "kind": "LinkedField",
        "name": "ch_deleteProgressNote",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "progressNote",
            "args": null,
            "concreteType": "ch_ProgressNote",
            "kind": "LinkedField",
            "name": "ch_ProgressNote",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "553c849de5d7c5a49bb06b6dec679dfc",
    "metadata": {},
    "name": "chDeleteProgressNoteMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7a3cdf7915f08966bbb2cd637f1672ba";

export default node;
